<template>
  <v-app>
    <header-bar />
    <app-bar />
    <!-- <drawer /> -->
    <v-main>
      <router-view />
    </v-main>
    <footer-bar />
  </v-app>
</template>

<script>
import HeaderBar from 'components/core/HeaderBar';
import AppBar from 'components/core/AppBar';
import Drawer from 'components/core/Drawer';
import FooterBar from 'components/core/FooterBar';

export default {
  name: 'App',
  components: {
    HeaderBar,
    AppBar,
    Drawer,
    FooterBar
  },
  mounted() {
    // 创建cnzz统计js
    const script = document.createElement('script')
    script.src = 'https://s9.cnzz.com/z_stat.php?id=1280057048&web_id=1280057048'
    script.language = 'JavaScript'
    document.body.appendChild(script)
  },
  watch: {
    '$route': {
      handler(to, from) {
        setTimeout(() => { //避免首次获取不到window._czc
          if (window._czc) {
            let location = window.location;
            let contentUrl = location.pathname + location.hash;
            let refererUrl = '/';
            // 用于发送某个URL的PV统计请求，
            window._czc.push(['_trackPageview', contentUrl, refererUrl])
            window._czc.push(["_setAutoPageview", false]);
          }
        }, 300)
      },
      immediate: true  // 首次进入页面即执行
    }
  }
}
</script>

<style lang="sass">
#app
  // background: url('assets/img/background-img.png') no-repeat center center fixed !important
  // background: url('assets/background.png') repeat center center fixed !important
  // background-size: cover
  // width: 100%
  // height: 100%

a
  text-decoration: none

a:hover
  text-decoration: none
</style>